// Datumfilters — platformregel: "Van" telt mee, "Tot" NIET (04-11-2026).
//
// Elk venster "Van … Tot …" is half-open. Van 01/09/2026 tot 01/10/2026 is dus
// precies september: dertig dagen, de einddag zelf niet. Zo sluiten opeenvolgende
// vensters naadloos op elkaar aan en hoeft niemand te weten of een maand 30 of
// 31 dagen telt. Het label op het scherm is daarom altijd "Tot", nooit
// "Tot en met"; dezelfde regel geldt voor maandfilters ("tot maart" = t.e.m.
// februari).
//
// De API's en de rekenkernen (metering.js, /api/market/export, /api/lynx/…)
// verwachten de LAATSTE dag die meetelt. Zet een "tot" van het scherm daarvoor
// om met laatsteDag(); bouw een "tot" uit een inclusieve einddag (bv. het einde
// van de getoonde periode) met totNa(). Reken het aantal dagen met
// dagenInVenster(), nooit met "+ 1".
export const FILTER_TOT_EXCLUSIEF = true;

export const ISO_DAG_RE = /^\d{4}-\d{2}-\d{2}$/;
export const ISO_MAAND_RE = /^\d{4}-\d{2}$/;

const pad = (n) => String(n).padStart(2, '0');

// Kalenderdag `dagen` verder (negatief = terug), als 'YYYY-MM-DD'. Rekent in UTC
// op de datumtekst, dus zonder invloed van tijdzone of zomertijd.
export function schuifDag(iso, dagen) {
  if (!ISO_DAG_RE.test(iso || '')) return null;
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + dagen));
  return `${dt.getUTCFullYear()}-${pad(dt.getUTCMonth() + 1)}-${pad(dt.getUTCDate())}`;
}

// De laatste dag die nog in het venster valt: de dag vóór "tot".
export const laatsteDag = (tot) => schuifDag(tot, -1);

// De "tot"-waarde die een inclusieve einddag precies insluit: de dag erna.
export const totNa = (laatste) => schuifDag(laatste, 1);

// Aantal dagen in het venster [van, tot). Null wanneer een grens ongeldig is of
// het venster leeg (tot op of vóór van).
export function dagenInVenster(van, tot) {
  if (!ISO_DAG_RE.test(van || '') || !ISO_DAG_RE.test(tot || '') || tot <= van) return null;
  return Math.round((Date.parse(`${tot}T00:00:00Z`) - Date.parse(`${van}T00:00:00Z`)) / 86400000);
}

// Is het venster bruikbaar: beide grenzen geldig en minstens één dag lang?
export const vensterGeldig = (van, tot) => dagenInVenster(van, tot) != null;

// Maandvarianten ('YYYY-MM'): de maand na / vóór een gegeven maand.
export function schuifMaand(maand, maanden) {
  if (!ISO_MAAND_RE.test(maand || '')) return null;
  const [y, m] = maand.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1 + maanden, 1));
  return `${dt.getUTCFullYear()}-${pad(dt.getUTCMonth() + 1)}`;
}
export const maandNa = (maand) => schuifMaand(maand, 1);
export const laatsteMaand = (tot) => schuifMaand(tot, -1);
